"use strict";
import { ItemRuntime } from "@/components/virtual-desktop/item";
import { Timestamp } from "@/components/virtual-element/utils";
import { ShopModelPro } from "@/models/shop.model";
import { TagsModel } from "@/models/tags.model";
export class VirtualLastInfoItem {
  constructor() {
    this.lastTime = 0;
    this.lastUser = null;
  }
  get lastDate() {
    return new Timestamp(this.lastTime);
  }
}
export class ButtonStatus {
  constructor() {
    this.model = "button.status";
    this.button = "";
    this.disabled = false;
  }
}
export class OnlineList {
  constructor() {
    this.datas = [];
    this.total = 0;
  }
}
export class VirtualShopItem {
  constructor() {
    this._resource = new ShopModelPro();
    this.id = null;
    this.shopOldId = null;
    this.name = null;
    this.icon = null;
    this.proxy = null;
    this.ebusiness = null;
    this.ebusinessName = null;
    this.region = null;
    this.marks = new TagsModel();
    // status:string | null = null;
    this.users = 0;
    this.launcher_progress = 0;
    this.remote_launcher_progress = 0;
    this.lastInfo = new VirtualLastInfoItem();
    this.button_status = new ButtonStatus();
    this.vd = null;
    this.iconTag = null;
    this.vd_guid = null;
    this.remark = null;
    this.shopSort = null;
    this.onLineList = new OnlineList();
    this.runtime = new ItemRuntime();
    this.shopLock = false;
    this.lockStatus = false;
  }
  static create(item) {
    const _item = new this();
    _item.id = item.id;
    _item.name = item.name;
    _item.icon = item.ebusiness.logo;
    _item.marks = item.marks;
    return _item;
  }
  get modelResource() {
    return this._resource;
  }
  set modelResource(model) {
    this._resource = model;
  }
}
export class VirtualShopItemColumn extends VirtualShopItem {
  constructor() {
    super(...arguments);
    this.status = null;
    this.last_launcher = 0;
  }
  static create(item) {
    var _a;
    const _item = new this();
    _item.id = item.id;
    _item.shopOldId = item.shopOldId;
    _item.name = item.name;
    _item.icon = item.ebusiness.logo;
    _item.ebusiness = item.ebusinessPlatform.name;
    _item.ebusinessName = item.ebusiness.name;
    _item.iconTag = item.icon;
    _item.region = item.region;
    _item.proxy = item.address;
    _item.users = item.authUserCount;
    _item.vd = item.vd;
    _item.status = item.status;
    _item.shopLock = item.lock;
    _item.vd_guid = item.vd === null ? null : item.vd.id;
    _item.modelResource = item;
    _item.marks = new TagsModel();
    _item.marks.tags = item.marks.tags;
    if (item.vd === null) {
      _item.marks.add("NO_BIND_VD");
    }
    _item.onLineList = new OnlineList();
    if (item.lastlogin) {
      _item.lastInfo.lastTime = item.lastlogin.time;
      _item.lastInfo.lastUser = item.lastlogin.name;
    }
    _item.remark = item.remark;
    _item.shopSort = (_a = item.shopSort) != null ? _a : null;
    _item.lockStatus = item.lockStatus;
    return _item;
  }
}
